"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StarFull;

var React = _interopRequireWildcard(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}
/* eslint-disable */


function StarFull(props) {
  var color = props.color,
      size = props.size,
      customColor = props.customColor,
      className = props.className,
      dataTest = props.dataTest,
      ariaHidden = props.ariaHidden,
      ariaLabel = props.ariaLabel,
      reverseOnRtl = props.reverseOnRtl;
  return React.createElement(_Icon.default, {
    viewBox: "0 0 24 24",
    size: size,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("path", {
    d: "M21.92 9.19a1.292 1.292 0 0 0-1.207-.84h-5.225a.43.43 0 0 1-.405-.287l-1.876-5.316a1.288 1.288 0 0 0-2.412 0l-.004.013L8.92 8.063a.43.43 0 0 1-.405.286H3.29a1.288 1.288 0 0 0-.827 2.276l4.45 3.691a.43.43 0 0 1 .133.466l-1.87 5.606a1.288 1.288 0 0 0 1.983 1.446l4.59-3.365a.43.43 0 0 1 .507 0l4.587 3.364a1.288 1.288 0 0 0 1.984-1.445l-1.87-5.61a.43.43 0 0 1 .134-.465l4.458-3.697a1.288 1.288 0 0 0 .372-1.425z"
  }));
}